import React, { useState, useEffect, useContext } from 'react';
import { getRuPageSlug, checkRU } from '../../index';
import RouteUrl from '../RouteEnum';
import axios from 'axios';

import ModalContext from '../MakeAppointmentModal/ModalProvider';
import PackageOfferList from '../PackageOffers/PackageOfferList';
import SaleOfferList from '../SaleOffers/SaleOfferList';
import Footer from '../PageComponents/Footer';
import Header from '../PageComponents/Header';
import ErrorWrapper from "../PageComponents/ErrorWrapper";
import Map from "../PageComponents/Map";


import "./Page.css";


const OffersPage = () => {
    const { isRu, apiUrl } = checkRU();
    const [data, setData] = useState({});
    const [error, setError] = useState(false);
    const { modalOn, modalData } = useContext(ModalContext);
    const path = [{ link: "", title: isRu ? "Акции" : "Акції" }];

    const BUTTON_TEXT = isRu ? "ЗАПИСАТЬСЯ НА ПРИЕМ" : "ЗАПИСАТИСЯ НА ПРИЙОМ";

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get(getRuPageSlug(RouteUrl.offers)).then(res => {
            setData(res.data);
        }).catch(err => setError(true));
    }, []);

    const onClick = () => {
        isRu ? modalData("Прием у врача", "ЗАПИСАТЬСЯ НА ПРИЕМ") : modalData("Прийом у лікаря", "ЗАПИСАТИСЯ НА ПРИЙОМ");
        modalOn();
    };

    return (
        <ErrorWrapper error={error}>
            <Header path={path} data={ data } />
            <div className="frame">
                <h1 className="main-header">{isRu ? "АКЦИОННЫЕ ПРЕДЛОЖЕНИЯ" : "АКЦІЙНІ ПРОПОЗИЦІЇ"}</h1>
                <SaleOfferList />

                <h1 className="main-header">{isRu ? "ПАКЕТНЫЕ ПРЕДЛОЖЕНИЯ" : "ПАКЕТНІ ПРОПОЗИЦІЇ"}</h1>
                <PackageOfferList show="-1" />

                <div style={{ textAlign: "center" }}><button className="offers-button" onClick={onClick} ><h2 className="h2-button">{BUTTON_TEXT}</h2></button></div>
                <Map />
            </div>
            <Footer nested="1" />
        </ErrorWrapper>
    );
}

export default OffersPage;